<template>
<div data-w-tab="Tab 6" class="">
    <div class="doc_tabdiv">
        <div class="doctab_flex-div">
            <div class="doctab_textdiv"><img loading="lazy" src="images/icon_docbag_rx.svg" alt="" class="image-568 hide">
                <div class="doctab_toptextdiv">
                    <div class="text-block-1262">Doctor on Demand</div>
                    <div class="text-block-1263 mobile"><span class="text-span-277">Response time is less than 24 hours.</span><br>We will notify you by text when they respond.</div>
                </div>
                <div class="doctor-profile-div">
                    <div class="div-block-2086">
                        <div class="doc_picdiv">
                            <img
                                :src="getDocImage(doctorProfile) || require('@/assets/images/doctor-svgrepo-com.svg')"
                                loading="lazy"
                                alt="Doctor profile"
                                />
                        </div>
                        <div class="doc_namediv">
                            <div class="text-block-1277">Dr. {{ doctorProfile?.name || '' }}</div>
                            <div class="doc_npi_div">
                                <div class="text-block-1278">NPI#:</div>
                                <div class="text-block-1279">{{ doctorProfile?.npi || '' }}</div>
                            </div>
                        </div>
                    </div>
                    <p class="doc_short-bio">{{ doctorProfile?.bio || '' }}</p>
                    <a href="#" class="link-block-84 w-inline-block"  @click="toggleDoctorChat()">
                        <div class="text-block-1280">Send Message</div><img loading="lazy" src="@/assets/images/icon_SMS.svg" alt="" class="image-556">
                    </a>
                </div>
                <p class="paragraph-162">Use this chat to ask your doctor questions about your treatments, side effects and any other medical questions you may have.</p>
                <div class="text-block-1263 desk"><span class="text-span-277">Response time is less than 24 hours.</span><br>We will notify you by text when they respond.</div>
                <div class="div-block-1988">
                    <div class="text-block-1264 desktop"><span class="text-span-280">!!!</span> If you have billing, shipping, customer service, pharmacy or any other questions please click the button below</div>
                    <div class="text-block-1264 mobile">
                        <a href="#" class="link-74"><span class="text-span-280">!!!</span> If you have billing, shipping, customer service, pharmacy or any other questions please click here <span class="text-span-329">-&gt;</span></a>
                    </div>
                    <a href="#" style="display:block" class="button-125 w-button" @click.prevent="showChatWindow()">Chat with Customer Service</a>
                </div>
            </div>
            <div class="doctab_chat-div">
                <div class="w-embed" ref="dochatmdi" v-if="shouldShowDocChat">
                    <iframe src="https://patient.mdintegrations.com/tabs/messages?fullscreen=true" style="height:80vh; width: 100%; min-height: 450px;border: none;"></iframe>
                </div>
                <div class="w-embed"  v-else>
                    <docChat :encounterId="currentEncounterId"/>
                </div>
                
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapGetters
} from 'vuex';
import docChat from '../chat/docChat.vue'
export default {
    props: {
        baseUrl: {
            type: String,
            required: true
        }
    },
    components: {
        docChat
    },
    data() {
        return {
            doctorProfile: null,
            loading: true,
            error: null,
            showmobile:true,
        }
    },

    computed: {
        ...mapGetters(['getCase', 'docProfile','getLatestEncounter']),
        
        // Make these computed properties reactive to store changes
        shouldShowDocChat() {
            // Show external MDI chat for provider 1, custom docChat for provider 3
            if (this.getLatestEncounter && this.getLatestEncounter.provider === 1) {
                return true;
            }
            
            // Show custom docChat for provider 3 or when no specific provider
            return false;
        },
        
        hasProvider3Order() {
            return this.$store.getters.progressItems?.some(order => order.provider === 3) || false;
        },
        
        availableExternalVisitId() {
            const ordersWithVisitId = this.$store.getters.progressItems?.filter(order => order.external_visit_id);
            return ordersWithVisitId && ordersWithVisitId.length > 0 ? ordersWithVisitId[0].external_visit_id : null;
        },
        
        currentEncounterId() {
            // First try getLatestEncounter
            if (this.getLatestEncounter) {
                const encounterId = this.getLatestEncounter.encounter_id || 
                                  this.getLatestEncounter.id || 
                                  this.getLatestEncounter.encounterId;
                if (encounterId) return encounterId;
            }
            
            // Fallback to availableExternalVisitId
            return this.availableExternalVisitId;
        }
    },

    watch: {
        // Watch for changes in progressItems to set up encounter data
        '$store.getters.progressItems': {
            immediate: true,
            deep: true,
            handler(progressItems) {
                if (progressItems && progressItems.length > 0) {
                    this.setupEncounterData();
                }
            }
        },
        
        // Watch for encounter changes to fetch doctor profile
        currentEncounterId: {
            immediate: true,
            handler(newEncounterId) {
                if (newEncounterId) {
                    this.fetchDoctorProfile();
                }
            }
        },

        // Watch for changes in docProfile from Vuex
        docProfile: {
            immediate: true,
            handler(newProfile) {
                if (newProfile) {
                    this.doctorProfile = newProfile;
                    this.loading = false;
                }
            }
        },

        // Watch for changes in encounter data
        getLatestEncounter: {
            immediate: true,
            deep: true,
            handler() {
               
                this.$forceUpdate();
            }
        }
    },

    methods: {
        setupEncounterData() {
            // Set encounter data if we have provider 3 order and external_visit_id
            if (this.hasProvider3Order && this.availableExternalVisitId) {
                if (!this.getLatestEncounter || this.getLatestEncounter.provider !== 3) {
                    this.$store.dispatch('setEncounterId', {
                        encounter_id: this.availableExternalVisitId,
                        provider: 3,
                        id: this.availableExternalVisitId
                    });
                }
            }
        },
        
        getDocImage(docProfile){
            try{
                if (!docProfile) return null;
                return docProfile.image || null;
            }catch(error){
                console.log(error)
                return null
            }
        },
        showChatWindow() {
            this.$root.$emit('toggle-chat');
        },
        async toggleDoctorChat() {
            if (this.shouldShowDocChat) {
                await this.$store.dispatch('toggeleDocChat');
            } else {
                this.$nextTick(() => {
                    const el = this.$refs.dochatmdi;
                    if (el && el.scrollIntoView) {
                        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                });
            }
        },
        async fetchDoctorProfile() {
            try {
                // Validate encounter ID exists and is valid format
                if (!this.currentEncounterId) {
                    console.warn('No encounter ID available, skipping doctor profile fetch');
                    return;
                }
                
                // Validate encounter ID format (should be UUID-like)
                if (typeof this.currentEncounterId !== 'string' || this.currentEncounterId.length < 10) {
                    throw new Error('Invalid encounter ID format');
                }

                this.loading = true;
                console.log(`Calling API: ${this.baseUrl}/api/get-doc-profile/${this.currentEncounterId}`);
                const response = await this.$axios.get(`${this.baseUrl}/api/get-doc-profile/${this.currentEncounterId}`);
                console.log('Full API response:', response);
                console.log('Response data:', response.data);
                
                // Check if we have any data
                if (!response?.data) {
                    throw new Error('No data returned from API');
                }
                
                // Try different possible response structures
                let profileData = null;
                if (response.data.case) {
                    profileData = response.data.case;
                } else if (response.data.doctor) {
                    profileData = response.data.doctor;
                } else if (response.data.profile) {
                    profileData = response.data.profile;
                } else if (response.data.data) {
                    profileData = response.data.data;
                } else if (typeof response.data === 'object' && response.data.name) {
                    profileData = response.data;
                } else {
                    throw new Error(`Unexpected API response structure: ${JSON.stringify(response.data)}`);
                }

                console.log('Extracted profile data:', profileData);

                // Update Vuex store and local state
                await this.$store.dispatch('setDocProfile', profileData);
                this.doctorProfile = profileData;

            } catch (error) {
                console.error('Error fetching doctor profile:', error);
                this.error = error.message || 'Failed to load doctor profile';
                this.doctorProfile = null;
            } finally {
                this.loading = false;
            }
        }
    },

    created() {
        // Don't call fetchDoctorProfile immediately - let the watchers handle it
        // This prevents race conditions with progressItems loading
        console.log('Component created, watchers will handle data loading');
    },

    // Add mounted hook to ensure we have the latest data when tab becomes active
    mounted() {
        
    },

    // Add activated hook for keep-alive components (if you're using keep-alive)
    activated() {
        console.log('talkToDoc activated, current encounter:', this.getLatestEncounter);
        // Force update when tab becomes active
        this.$nextTick(() => {
            this.$forceUpdate();
        });
    }
}
</script>
<style>
.show-on-mobile {
        display: none;
    }
@media (max-width: 768px) {
    .show-on-mobile {
        display: block;
    }
}

</style>
